import React, { useEffect, useState } from 'react'
import classNames from 'classnames'
import classes from './InviteForm.module.css'
import { ReactComponent as CloseIcon } from '../../../assets/icons/close.svg'
import { ValidatedFormInput, ValidatedFormTextArea } from '../Inputs/Inputs'
import { Button } from '../../Button/Button'
import { Formik } from 'formik'
import { InviteFormSchema } from '../../../util/formSchemas'
import { useDispatch, useSelector } from 'react-redux'
import {
    businessUsersActions,
    businessUsersSelectors,
} from '../../../pages/Business/Users/businessUsersSlice'
import { userSelectors } from '../../../redux/userSlice'
import {
    getBusinessBeneficiaries,
    inviteBeneficiary,
} from '../../../pages/Business/Users/businessUsersApi'
import notification from '../../Notification/notification'

export const InviteForm = ({
    open = false,
    onRequestClose,
    className,
    ...props
}) => {
    const [submitting, setSubmitting] = useState(false)

    const dispatch = useDispatch()

    const isSubmitting = useSelector(businessUsersSelectors.inviteIsSubmitting)
    const hasError = useSelector(businessUsersSelectors.inviteHasError)
    const errorMessage = useSelector(businessUsersSelectors.inviteErrorMessage)

    const user = useSelector(userSelectors.userDetails)

    const closeForm = () => {
        if (!submitting && typeof onRequestClose === 'function')
            onRequestClose()
    }

    const submitForm = values => {
        dispatch(
            inviteBeneficiary({ email: values.email, addedby: user.email })
        )
        notification.loading({
            title: 'Inviting',
        })
        onRequestClose()
        setSubmitting(true)
    }

    useEffect(() => {
        if (!isSubmitting) {
            notification.destroy()
            if (hasError) {
                notification.failure({
                    title: 'Something went wrong',
                    description: errorMessage,
                })
            } else {
                notification.success({
                    title: 'Success!',
                    description: 'User invited',
                })
                dispatch(getBusinessBeneficiaries(user.email))
            }
            dispatch(businessUsersActions.inviteUsersReset())
            setSubmitting(false)
        }
    }, [isSubmitting])

    return (
        <Formik
            initialValues={{ email: '', message: '' }}
            onSubmit={submitForm}
            validationSchema={InviteFormSchema}
        >
            {({ handleSubmit }) => (
                <form
                    onSubmit={handleSubmit}
                    className={classNames(
                        classes.inviteForm,
                        open && classes.inviteFormOpen,
                        className
                    )}
                    {...props}
                >
                    <button
                        className={classes.closeButton}
                        onClick={closeForm}
                        type="button"
                        disabled={submitting}
                    >
                        <CloseIcon className={classes.closeButtonIcon} />
                    </button>
                    <div className={classes.inviteFormContent}>
                        <h1 className={classes.formTitle}>Invite User</h1>
                        <div className={classes.inputRow}>
                            <ValidatedFormInput
                                type="email"
                                name="email"
                                label="Email address"
                                placeholder="Enter user email address here"
                                required
                            />
                        </div>
                        <div className={classes.inputRow}>
                            <ValidatedFormTextArea
                                name="message"
                                label="Custom message"
                                placeholder="Add custom message"
                                required
                            />
                        </div>
                        <div className={classes.formAction}>
                            <Button
                                type="submit"
                                disabled={submitting}
                                onClick={handleSubmit}
                            >
                                Invite User
                            </Button>
                        </div>
                    </div>
                </form>
            )}
        </Formik>
    )
}
